import { twJoin } from 'tailwind-merge';

import { Skeleton } from '@/_components';
import { CardContainer, SectionHeadingSkeleton } from '@/_containers';

export function WidgetSkeletonLoader({ className, showFooter }: { className?: string; showFooter?: boolean }) {
  return (
    <CardContainer className={className} bodyClassName="3xl:px-4 px-4 pb-0">
      <SectionHeadingSkeleton withIcon />
      <ul className={twJoin('mt-6 list-none', className)}>
        {Array.from({ length: 6 }).map((_, index) => (
          <li
            key={index}
            className="border-c-border-muted text-accent flex h-12 flex-nowrap items-center justify-between gap-2 border-b dark:text-white"
          >
            <div className="flex flex-1 items-center gap-1.5">
              <Skeleton className="h-7 w-9 shrink-0 grow-0 rounded-md" />
              <div className="flex w-full flex-col gap-1">
                <Skeleton className="h-4 w-full" />
                <Skeleton className="h-4 w-3/4" />
              </div>
            </div>
            <Skeleton className="h-4 w-16" />
          </li>
        ))}
      </ul>
      {showFooter && <div className="mt-6 h-4 w-full" />}
    </CardContainer>
  );
}
